import { type PermissionOverride } from '../types'
import { PERMISSION_TYPES, type PermissionType } from '../definition'
import { TERROS_CX_TEAM_ID, TERROS_TECH_TEAM_ID } from '../../team'
import { type TeamId } from '../../ids'
import { DEFAULT_USER } from './user'
import { DEFAULT_TEAM_MANAGER } from './manager'
import { DEFAULT_COMPANY_ADMIN } from './admin'

const ADMIN_PERMISSIONS: PermissionType[] = DEFAULT_COMPANY_ADMIN.permissionOverrides?.map(toPermissionType) ?? []
const MANAGER_PERMISSIONS: PermissionType[] = DEFAULT_TEAM_MANAGER.permissionOverrides?.map(toPermissionType) ?? []
const USER_PERMISSIONS: PermissionType[] = DEFAULT_USER.permissionOverrides?.map(toPermissionType) ?? []

// Permissions that are not part of the default roles
export const TERROS_COMMON_PERMISSIONS: PermissionType[] = ['company:list', 'user:login']
export const TERROS_TEAM_OVERRIDES: Map<TeamId, PermissionType[]> = new Map([
  [TERROS_CX_TEAM_ID, ['company:add', 'location:manage']],
  [TERROS_TECH_TEAM_ID, PERMISSION_TYPES],
])

export const TERROS_USER_PERMISSIONS: PermissionType[] = [
  ...ADMIN_PERMISSIONS,
  ...MANAGER_PERMISSIONS,
  ...USER_PERMISSIONS,
  ...TERROS_COMMON_PERMISSIONS,
]

function toPermissionType(permission: PermissionOverride<PermissionType>): PermissionType {
  return permission.permissionType
}
